(function() {
    let obj;
 
    Object.defineProperty(window, "tlCartGoalEmbed", {
        get() {
            if (obj) {
                obj.defaultCartSelector = '#mu-header + div';
                obj.defaultEmptyCartSelector = '#mu-header';
                obj.defaultCartPosition = 'afterbegin';
                obj.defaultEmptyCartPosition = 'afterend';
            }

            return obj;
        },
        set(val) {

            if (val && !obj) {

                const style = document.createElement("style");
                style.innerHTML = `
                    .tl__cart-goal__container__drawer {
                        background: transparent !important;
                    }
                    .tl__cart-goal__goal-check-point-value {
                        visibility: visible !important;
                    }
                    .tl__cart-goal__goal-check-point-title {
                        visibility: visible !important;
                    } 
                    .tl__cart-goal__goal-container__drawer {
                        background-color: #d7a76d !important;
                    }
                    .tl__cart-goal__goal-process__drawer {
                        background-color: #7d4627 !important;
                    }
                    .tl__cart-goal__goal-check-point__drawer {
                        border-color: #7d4627 !important;
                        border-width: 2px !important;
                        background-color: #7d4627 !important;
                    }
                `;
                document.head.appendChild(style);

                val.getDefaultTarget = function (type) {
                    switch (type) {
                        case "cartDrawer":
                            return {
                                selector: "#mu-header + div",
                                position: "afterbegin"
                            }; 
                        case "cartPage":
                            return {
                                selector: window.tlCartGoalEmbed.cartItems.length ? window.tlCartGoalEmbed.defaultCartSelector : window.tlCartGoalEmbed.defaultEmptyCartSelector,
                                position: window.tlCartGoalEmbed.cartItems.length ? window.tlCartGoalEmbed.defaultCartPosition : window.tlCartGoalEmbed.defaultEmptyCartPosition
                            };
                        case "productPage":
                            return {
                                selector: window.tlCartGoalEmbed.defaultProductPageSelector,
                                position: window.tlCartGoalEmbed.defaultProductPagePosition,
                            };
                        default:
                            return {};
                    }
                };
                // val.defaultCartSelector = '#mu-header';
                // val.defaultCartPosition = 'afterend';

                obj = val;
            }
 
        },
        configurable: true
    });
})();